import React from 'react';

const Footer = () => {
  return (
    <footer className="kabini-footer">
      {/* Footer content commented out as in original */}
      <div className="footer-bottom">
        <span>© 2025 Kabini · nature & stay. All rights reserved.</span>
        <br /><br />
        <span>Designed and Developed by Madhu Computers.</span>
        <span style={{ float: 'right' }}>
          <a href="/privacy">privacy</a> • <a href="/terms">terms</a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;